// Seatmap design versions. Each value represents a distinct visual design of
// the seatmap so we can ship and toggle multiple designs side by side.
//
//   1 (LEGACY)   - the original default-brand seatmap look
//   2 (ENHANCED) - the "enhanced details" redesign, historically gated by the
//                  `use_seatmap_redesign` / `test_use_seatmap_redesign` variant
//   3 (NEW)      - the latest seatmap redesign
export const SEATMAP_DESIGN = {
  LEGACY: 1,
  ENHANCED: 2,
  NEW: 3,
};

// Resolve the active seatmap design version from the (booleanized) variants.
//
// Partners select a design explicitly via the `seatmap_design_version` variant
// (we also accept the `test_`-prefixed name for AB tests, matching the quirk
// described in the widgets). When no explicit version is set we fall back to
// the legacy boolean flag so existing partners that enabled the previous
// redesign keep getting it (ENHANCED).
export function getSeatmapDesignVersion(variants = {}) {
  const raw =
    variants.seatmap_design_version ?? variants.test_seatmap_design_version;
  const n = Number(raw);
  if (raw != null && raw !== '' && !Number.isNaN(n)) {
    return n;
  }

  return variants.use_seatmap_redesign || variants.test_use_seatmap_redesign
    ? SEATMAP_DESIGN.ENHANCED
    : SEATMAP_DESIGN.LEGACY;
}

// True when the latest redesign should render.
export const isNewSeatmapDesign = (variants = {}) =>
  getSeatmapDesignVersion(variants) === SEATMAP_DESIGN.NEW;
